import React, { useEffect, useState } from 'react'
import { Form, message,Input, Modal, Select } from 'antd';
import axiosInstance from '../../../utils/axiosInstance';

const { TextArea } = Input;

const header  = ['business head','agreement controller head'] 
const  DeactivateUserModel=({handleCancel,isOpen,onSuccess,userId,role})=> {
   const [assignee, setAssignee] = useState([]);
    const [form] = Form.useForm();
      useEffect(() => {
        if(role){
          fetchAssignee(role);
          form.resetFields();
        }
      }, [role]);

    const handleSubmit = () => {

        form.validateFields().then((values) => {
          console.log(values, 'values')
           axiosInstance.put( `/user/${userId}/active/`,{ active: false, reason: values.reason,user_id:values?.user_id } )
            .then((response) => {
              if (response.status === 200) {
                onSuccess()
                message.success("User deactivated successfully.");
                form.resetFields();
              } else {
                // setOpen(false);
                throw new Error("Error updating user status.");
              }
            })
            .catch((error) => {
              console.error(error.message);
            });
        });
      };
      const handleOk = () => {
        form.submit();
      };

  const fetchAssignee = async (role) => {
    try {
      const rol = 'Business Head'.toLowerCase() == role.toLowerCase() ? 'Businesshead' : role;
      const payload = {head_type:rol,id:userId }
      const response = await  axiosInstance.post( `/head_list/`,  payload)
      setAssignee(response.data); // Update the state with the fetched user data
    } catch (error) {
      console.error(error);
    }
  };
  const isHeader = ()=> { 
    const lowerRole = (role || '').toLowerCase();
   return header.includes(lowerRole)
  }
  return (
    <Modal
    title="Deactivate"
    open={isOpen}
    onOk={() => handleOk()}
    onCancel={handleCancel}
>
    <Form form={form} onFinish={handleSubmit}>
        <Form.Item
            name="reason"
            label="Reason"
            rules={[
                {
                    required: true,
                    message: "Please enter deactivation reason.",
                },
            ]}
        >
            <TextArea />
        </Form.Item>
              {isHeader() && (
        <Form.Item
          name="user_id"
          label="Choose Head"
          style={{ marginBottom: 20 }}
          rules={[
            {
              required: true,
              message: "Please select a assignee",
            },
          ]}
        >
          <Select
            options={
              assignee
                ? Object.values(assignee).filter((item => item.id != userId)).map((user) => ({
                  value: user.id,
                  label: user.first_name,
                }))
                : []
            }
            // onChange={(selectedOption) =>
            //     setDepartment(selectedOption.value)
            // }
            required
          />
        </Form.Item>
      )}

    </Form>
</Modal>
  )
}
export default DeactivateUserModel